/* Video erst auf Klick laden — bis dahin liegt nur das Standbild in der Seite.
   Spart Ladezeit und verhindert, dass fremde Skripte ungefragt mitlaufen. */
(function () {
  'use strict';

  function einbetten(quelle) {
    var yt = quelle.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vi = quelle.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vi) return 'https://player.vimeo.com/video/' + vi[1] + '?autoplay=1';
    return null;
  }

  function start(taste) {
    taste.addEventListener('click', function () {
      var buehne = taste.closest('[data-sk-video-buehne]');
      var url = einbetten(taste.getAttribute('data-sk-video-quelle') || '');
      if (!buehne || !url) return;

      var rahmen = document.createElement('iframe');
      rahmen.className = 'sk-video__rahmen';
      rahmen.setAttribute('src', url);
      rahmen.setAttribute('title', taste.getAttribute('aria-label') || 'Video');
      rahmen.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      rahmen.setAttribute('allowfullscreen', '');
      rahmen.setAttribute('loading', 'lazy');

      buehne.innerHTML = '';
      buehne.appendChild(rahmen);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-video-start]'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
